import { createVueApp } from '../../common/createVueApp';
import store from '../../common/store/store';
import Login from './views/Login.vue';

store.dispatch('logout');

createVueApp(Login);
